import { put, takeEvery, select, call, take } from "redux-saga/effects";
import { actions, selectors } from "redux-store";
import { LanguageValues } from "models/Language";
import i18n from "i18next";
import { SetUserLanguageAction } from "redux-store/slices/user/interfaces";
import { push } from "connected-react-router";

export function* userLoggedInSaga() {
  yield takeEvery(actions.cognitoSetTokens, function* () {
    yield put(actions.getUsersMe.request({}));
    const resultAction = yield take([
      actions.getUsersMe.success.type,
      actions.getUsersMe.fail.type,
    ]);
    if (resultAction.type === actions.getUsersMe.success.type) {
      // We redirect to the merchants page only if we are not already on it, or on a merchant dashboard
      const pathname = yield select(selectors.getRouterPathname);
      if (pathname.indexOf("merchant") === -1) {
        yield put(push("/merchants/"));
      }
    } else {
      yield put(actions.clearSession());
    }
  });
}

export function* cognitoSignOutCodeSaga() {
  yield takeEvery(actions.clearSession, function () {
    caches.delete("pages");
  });
}

export function* i18nChangeLanguageSaga() {
  yield takeEvery([actions.setUserLanguage], function* (
    action: SetUserLanguageAction,
  ) {
    yield call(i18n.changeLanguage.bind(i18n), action.payload);
  });
}

export function* i18nInitLanguageDetectionSaga() {
  yield takeEvery([actions.appStartup], function* () {
    const currentUserLanguage = yield select(selectors.getUserLanguage);
    if (!currentUserLanguage) {
      const initialLanguage =
        (i18n.language?.split("-")?.[0] as LanguageValues) ?? LanguageValues.en;
      yield put(actions.setUserLanguage(initialLanguage));
    } else {
      yield call(i18n.changeLanguage.bind(i18n), currentUserLanguage);
    }
  });
}
